/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2024 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import { showInventoryToggleStyles } from "@monsma/Overrides/Components/ShowInventoryToggle";
import { css } from "styled-components";

showInventoryToggleStyles.toggleTypography = {
    css: css`
        text-transform: capitalize;
        font-size: 14px;
        font-weight: bold;
        color: ${getColor("common.backgroundContrast")};
    `,
};

showInventoryToggleStyles.toggleIcon = {
    size: 16,
    color: "common.ui9",
    css: css`
        margin-right: 10px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
    `,
};
